export default "__VITE_ASSET__DqMRrHGO__"